import { defa, T } from 'defa-object';
import aDateFormat from 'scripts/vendor/date-format-1.2.3';

const dateFormat = aDateFormat();


function setupDateFormat() {
	dateFormat.i18n = {
		dayNames  : T.dayNames,
		monthNames: T.monthNames,
	};
	
	// For convenience...
	Date.prototype.format = function ( mask, utc ) {
		return dateFormat( this, mask, utc );
	};
	
}

export {
	setupDateFormat, dateFormat
};